module.exports = __webpack_public_path__ + "img/menu1.4d63aa8b.svg";